import { Typography } from "@mui/material";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { IssuedKeyDto } from "./dtos/IssuedKeyDto";
import { dataGridSx } from "../../styles/bhpStyles";
import { useState, useEffect } from "react";
import { getUniqueItems } from "../../utils";


const columns: GridColDef[ ] = [ 

    {
        field: 'village',
        headerName: 'Village',
        width: 200,
    },
    
    {
        field: 'cardholder',
        headerName: 'Cardholder',
        width: 175,
    },

    {
        field: 'visitor',
        headerName: 'Visitor',
        width: 175,
    },

];


type IssuedKeysStatsProps = {

    issuedKeys: IssuedKeyDto[ ];

};

type DataRow = {
    
    village: string;
    cardholder: number;
    visitor: number;

};


export const IssuedKeysStats: React.FC< IssuedKeysStatsProps > = ( props: IssuedKeysStatsProps ) => {

    const { issuedKeys } = props;

    const [ rows, setRows ] = useState< DataRow[ ] >( [ ] );

    useEffect( () => {

        const rows: DataRow[ ] = [ ];

        const villages = getUniqueItems( issuedKeys.map( m => m.village ) );
        
        for( const village of villages ){

            let visitorKeys = 0, cardholderKeys = 0;

            const visitorKeysArray = issuedKeys.filter( m => m.village === village && m.keyIssuedTo === 'Visitor' ).map( k => k.keyCount );
            
            if( visitorKeysArray.length > 0 ){
                
                visitorKeys = visitorKeysArray.reduce( ( a, b ) => a + b );

            }

            const cardholderKeysArray = issuedKeys.filter( m => m.village === village && m.keyIssuedTo === 'Card Holder' ).map( k => k.keyCount );
            
            if( cardholderKeysArray.length > 0 ){

                cardholderKeys = cardholderKeysArray.reduce( ( a, b ) => a + b );

            }

            rows.push({

                village,
                cardholder: cardholderKeys,
                visitor: visitorKeys,

            });

        }

        setRows( rows );


    }, [ issuedKeys ] );

    

    



    return(

        <>
        
            <Typography sx={{ marginTop: '10px', color: '#e65400', fontWeight: 'bold', fontSize: '25px' }}>WiFi PSK Issued</Typography>

            {

                issuedKeys.length === 0 
                    ? 
                <Typography sx={{ marginTop: '15px' }}>No issued keys stats to display</Typography>
                    :
                <DataGrid
                    getRowId={ _ => Math.floor(Math.random() * 100_000_000) }
                    hideFooterPagination
                    hideFooterSelectedRowCount
                    hideFooter
                    rows={ rows }
                    columns={ columns }
                    autoHeight={ true }
                    sx={{ ...dataGridSx, width: 560, boxShadow: 5, marginTop: '5px !important' }}
                    sortingOrder={ [ 'desc', 'asc' ]}
                    disableSelectionOnClick
                />

            }

        </>

    );

};